var exports = {
  "wx": "PlutoniumSectionHeader.module__header___bzI4cW",
  "Pd": "PlutoniumSectionHeader.module__headerCenter___bzI4cW",
  "DD": "PlutoniumSectionHeader.module__title___bzI4cW",
  "h_": "PlutoniumSectionHeader.module__description___bzI4cW",
};

module.exports = exports;
